import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilledMailIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 12 9",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M0.037189 1.16658C0.188797 0.498628 0.786168 0 1.5 0H10.5C11.2138 0 11.8112 0.498627 11.9628 1.16658L6 4.81052L0.037189 1.16658ZM0 2.02281V7.35044L4.3524 4.68261L0 2.02281ZM5.07105 5.12179L0.143903 8.14192C0.384453 8.6492 0.901259 9 1.5 9H10.5C11.0987 9 11.6155 8.6492 11.8561 8.14192L6.92895 5.12179L6 5.68948L5.07105 5.12179ZM7.6476 4.68261L12 7.35044V2.02281L7.6476 4.68261Z",
		fill: "#007AAF"
	})]
});
const ForwardRef = forwardRef(SvgFilledMailIcon);
const Memo = memo(ForwardRef);
export default Memo;
